import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import {
  Header,
  HeaderParagraph,
  CarouselComponent,
  Button,
  Footer,
  Container,
  ContainerSubTitle,
  ContainerTitle,
  BodyWrapper,
  MobileFooter,
  Backgroundwrapper,
  OurClient,
  Input
} from '../components'
const TopWrapper = styled.div`
  max-width: 1366px;
  margin: 0 auto;
  @media (max-width: 768px) {
    padding: 40px 16px 20px;
    & > h1 {
      font-size: 28px !important;
      line-height: normal !important;
      letter-spacing: normal !important;
    }
    & > p {
      font-size: 16px !important;
      font-weight: 300 !important;
      line-height: 1.38 !important;
      letter-spacing: 0.1px !important;
    }
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 80px 250px 60px 80px;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  & > p {
    text-align: left;
    padding: 0;
    padding-top: 10px;
    font-size: 18px;
    font-weight: 300;
    line-height: 1.61;
  }
  & > h1 {
    font-size: 48px;
    line-height: 1.27;
    color: #333333;
  }
`

const ImageWrapper = styled.div`
  & > img {
    width: 100%;
    height: auto;
  }
`

const CarouselWrapper = styled.div`
  // height: 480px;
  margin-bottom: 100px;
`
const ClientsContainer = styled.div`
  & div.clientImage {
    img {
      max-width: 100%;
      width: 100%;
      height: 100%;
    }
  }
  & div.clientContent {
    padding: 40px 70px;
    @media (max-width: 640px) {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  @media (max-width: 768px) {
    & > img {
      height: 200px !important;
      width: 100% !important;
      object-fit: cover !important;
    }
    & > div > p:nth-child(2) {
      width: 100% !important;
    }
  }
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  & > img {
    height: 400px;
    max-width: 100%;
    object-fit: contain;
  }
  & > div {
    padding: 0;
    width: 50%;
    @media (max-width: 840px) {
      width: 100%;
    }
    & > img {
      width: 160px;
    }
    & > p:nth-child(2) {
      font-size: 20px;
      font-weight: normal;
      padding: 20px 0 30px 0;
      line-height: 1.6;
      color: #333333;
      @media (max-width: 640px) {
        font-size: 18px;
      }
    }
    & > p:nth-child(3) {
      font-size: 21px;

      line-height: 1.52;
      color: #333333;
    }
    & > p:nth-child(4) {
      font-size: 16px;
      font-weight: normal;
      line-height: 1.44;
    }
  }
`
const ClientImageWrapper = styled.div`
  max-width: 1366px;
  width: 100%;
  padding: 0 80px;
  margin: 0 auto;
  @media (max-width: 992px) {
    padding: 0 20px;
  }
  & > div:nth-child(odd) {
    flex-direction: row;
  }
  & > div:nth-child(even) {
    flex-direction: row-reverse;
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`

const TopContentWrapper = styled.div`
  max-width: 2560px;
  margin: 0 auto;
`

const FormWrapper = styled.form`
  display: flex;
  @media (max-width: 520px) {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
    & > div > input {
      width: 100%;
      margin-bottom: 10px;
    }
    & > button {
      width: 100%;
      border-radius 4px;
    }
  }
`

export class OurClients extends Component {
  render() {
    return (
      <Fragment>
        <Header />
        <TopContentWrapper>
          <TopWrapper>
            <HeaderParagraph
              headerColor={'#333333'}
              headerFontSize={'38px'}
              header={'Our Clients'}
              paragraph={'See yourself what our clients are saying about our services.'}
            />
          </TopWrapper>
          <ImageWrapper>
            <img src={require('../static/client-header.jpg')} alt="clients" />
          </ImageWrapper>
          <CarouselWrapper>
            <CarouselComponent carouselType="clients" />
          </CarouselWrapper>
        </TopContentWrapper>
        <ClientImageWrapper>
          <ClientsContainer>
            <div className="clientImage">
              <img src={require('../static/hari.jpg')} alt="clients" />
            </div>
            <div className="clientContent">
              <img src={require('../static/client_logo/munafamart.png')} alt="Munafamart" />
              <p>
                The technical support that we got from 8om made us understand a lot of things better which added to the
                progress of our store. 8om products like trckr and books made a lot of complex process simple and
                efficient.
              </p>
              <p>Hari Adhikari</p>
              <p>Head of Procurement</p>
            </div>
          </ClientsContainer>
          <ClientsContainer>
            <div className="clientImage">
              <img src={require('../static/mukul.jpg')} alt="clients" />
            </div>
            <div className="clientContent">
              <img src={require('../static/client_logo/teafloor.png')} alt="Teafloor" />
              <p>
                Their staff worked closely with our organization, and together we made excellent strides towards our
                goals. Their extensive internet experience and passion for e-commerce helped to turn our vision into
                reality
              </p>
              <p>Mukul Singhal</p>
              <p>CEO</p>
            </div>
          </ClientsContainer>
        </ClientImageWrapper>

        <Container normal background={'#fafbfc'} padding={'80px 0 80px 0'}>
          <ContainerTitle>Our Clients Around The World</ContainerTitle>
          <ContainerSubTitle>
            Our clients are valuable to us and we’re always inspired by them and their need to make their business
            better.
          </ContainerSubTitle>

          <Backgroundwrapper>
            <OurClient>
              <ul>
                <li>
                  <img src={require('../static/client_logo/baked-pizza.jpg')} alt="Baked" />
                </li>
                <li>
                  <img src={require('../static/client_logo/resplendentcosmetics.png')} alt="Resplendent Cosmetics" />
                </li>
                <li>
                  <img src={require('../static/client_logo/tanoshiitrail.png')} alt="Tanoshii Trail" />
                </li>

                <li>
                  <img src={require('../static/client_logo/m-tech.jpg')} alt="M-tech" />
                </li>

                <li>
                  <img src={require('../static/client_logo/munafamart.png')} alt="Munafamart" />
                </li>
                <li>
                  <img src={require('../static/client_logo/teafloor.png')} alt="Teafloor" />
                </li>
                <li>
                  <img src={require('../static/client_logo/vikas_spools.jpg')} alt="Vikas Spools" />
                </li>
                <li>
                  <img src={require('../static/client_logo/techrobotix.png')} alt="Techrobtix" />
                </li>
                <li>
                  <img src={require('../static/client_logo/phone.png')} alt="Phono Retail" />
                </li>
                <li>
                  <img src={require('../static/client_logo/bng.png')} alt="Blue n Greys" />
                </li>
                <li>
                  <img src={require('../static/client_logo/beccos.jpg')} alt="Beccos" />
                </li>
                <li>
                  <img src={require('../static/client_logo/erosgroup.png')} alt="Beccos" />
                </li>
                <li>
                  <img src={require('../static/client_logo/bonobology.jpg')} alt="Beccos" />
                </li>
                <li>
                  <img src={require('../static/client_logo/canon.png')} alt="Beccos" />
                </li>
                <li>
                  <img src={require('../static/client_logo/creatanium.png')} alt="Beccos" />
                </li>
                <li>
                  <img src={require('../static/client_logo/dubaipetroleum.png')} alt="Beccos" />
                </li>
                <li>
                  <img src={require('../static/client_logo/garagecafe.png')} alt="Beccos" />
                </li>
                <li>
                  <img src={require('../static/client_logo/ges.png')} alt="Beccos" />
                </li>
                <li>
                  <img src={require('../static/client_logo/golds.png')} alt="Beccos" />
                </li>
                <li>
                  <img src={require('../static/client_logo/governmentsarjah.png')} alt="Beccos" />
                </li>
                <li>
                  <img src={require('../static/client_logo/leverage_group.jpg')} alt="Beccos" />
                </li>
                <li>
                  <img src={require('../static/client_logo/greenchoice.png')} alt="Beccos" />
                </li>
                <li>
                  <img src={require('../static/client_logo/fractal.png')} alt="Beccos" />
                </li>
                <li>
                  <img src={require('../static/client_logo/home_registry.jpg')} alt="Beccos" />
                </li>
                <li>
                  <img src={require('../static/client_logo/huawei.png')} alt="Beccos" />
                </li>
                <li>
                  <img src={require('../static/client_logo/scale_labs.jpg')} alt="Beccos" />
                </li>
                <li>
                  <img src={require('../static/client_logo/pico.png')} alt="Beccos" />
                </li>
                <li>
                  <img src={require('../static/client_logo/truly_madly.jpg')} alt="Beccos" />
                </li>
                <li>
                  <img src={require('../static/client_logo/saudiaramco.png')} alt="Beccos" />
                </li>
                <li>
                  <img src={require('../static/client_logo/wickey.jpg')} alt="Beccos" />
                </li>
              </ul>
            </OurClient>
          </Backgroundwrapper>
        </Container>

        <Container background="#fafbfc" padding={'50px 0'}>
          <ContainerTitle>Get In Touch</ContainerTitle>
          <ContainerSubTitle paddingBottom="30px">
            Give your business the best tools to optimize your processes.
          </ContainerSubTitle>
          <form action="/contact" method="POST">
            <FormWrapper>
              <Input type="email" name="_replyto" icon="email" placeholder="Email" changeColor={'#35cc62'} />

              <Button
                radius={'0 4px 4px 0'}
                title={'Contact Us'}
                background={'#35cc62'}
                type="submit"
                formAction="/contact"
                method="POST"
              />
            </FormWrapper>
          </form>
        </Container>
        <BodyWrapper>
          <Footer />
          <MobileFooter />
        </BodyWrapper>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/OurClients.js